export default "__VITE_ASSET__FQqkm0Vn__"